import { SearchOutlined } from '@mui/icons-material';
import { Input } from '@mui/joy';
import React from 'react';
import { PoliceDefaut } from '../helpers/contants';

const SearchInput = props => {
  return (
    <Input
      onChange={e => props.filtre(e)}
      className="col"
      color="#134491"
      variant="outlined"
      startDecorator={<SearchOutlined />}
      placeholder={props.placeholder}
      sx={{
        '--Input-radius': '50px',
        backgroundColor: '#e4e4e4',
        width: '',
        fontFamily: PoliceDefaut,
        color: '#134491',
      }}
      type="search"
      value={props.value}
    />
  );
};

export default SearchInput;
